/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ early_bird_discount_percent: NonNullable<unknown> }} Subscription_Walkthrough_P4_TitleInputs */

const en_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Don’t Miss Out! Grab a<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>Early Bird Deal Today!</span>`)
};

const ar_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">لا تفوت الفرصة - احصل على<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>صفقة الحجز المبكر اليوم!</span>`)
};

const de_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Verpassen Sie nichts - schnappen Sie sich ein<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>Frühbucherangebot heute!</span>`)
};

const es_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">No te lo pierdas, consigue un<span style="[%2$s]">${i?.early_bird_discount_percent}% de descuento</span>hoy mismo como oferta anticipada</span>`)
};

const fr_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Ne passez pas à côté—Profitez d'une réduction de<span style="[%2$s]"> ${i?.early_bird_discount_percent}%</span> en tant que premiers utilisateurs aujourd'hui !</span>`)
};

const it_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Non perdere l'occasione: approfitta di un'offerta Early bird del <span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span> oggi stesso!</span>`)
};

const ja_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">早割特典<span style="[%2$s]">${i?.early_bird_discount_percent}%</span>をお見逃しなく！</span>`)
};

const ko_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">놓치지 마세요! <span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>오늘 얼리버드 특가!</span>`)
};

const pt_br_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Não perca — Obtenha hoje mesmo uma oferta antecipada de <span style="[%2$s]">${i?.early_bird_discount_percent}%</span>!</span>`)
};

const ru_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Не упустите возможность — получите <span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>предложение для ранних пташек уже сегодня!</span>`)
};

const th_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">อย่าพลาดโอกาส—คว้าข้อเสนอล่วงหน้า<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>วันนี้!</span>`)
};

const tr_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Fırsatı Kaçırma—Hemen Bugün<span style="[%2$s]"> %${i?.early_bird_discount_percent} </span>İndirimle Erken Rezervasyon Fırsatı!</span>`)
};

const zh_cn_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">现在购买，享有<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>早鸟折扣！</span>`)
};

const zh_tw_subscription_walkthrough_p4_title = /** @type {(inputs: Subscription_Walkthrough_P4_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">現在訂閱，享有<span style="[%2$s]"> ${i?.early_bird_discount_percent}% </span>早鳥折扣！</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Don’t Miss Out! Grab a<span style=\"[%2$s]\"> {early_bird_discount_percent}% </span>Early Bird Deal Today!</span>" |
*
* @param {Subscription_Walkthrough_P4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p4_title = /** @type {((inputs: Subscription_Walkthrough_P4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p4_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p4_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p4_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p4_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p4_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p4_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p4_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p4_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p4_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p4_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p4_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p4_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p4_title(inputs)
	return zh_tw_subscription_walkthrough_p4_title(inputs)
});